import React, { useState } from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';
import { setNotificationData } from '../../reducer/PEBCommonSlice';
import { NotificationTypes } from '../../shared/Notification/Notification';
import { addUserApi } from '../../services/ExperienceBankAPI';
const { Option } = Select;

const UserDetailsForm = ({ onCancel }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.PEBCommon?.userDetail);

 const handleSubmit = async () => {
  try {
    const values = await form.validateFields();
    const payload = {
      user_id: userInfo?.user_id,
      first_name: values.firstName,
      last_name: values.lastName,
      email_id: values.emailId,
      user_type: values.userType,
      user_group_name: values.userGroupName || "",
    };

    const response = await addUserApi(payload); // wire up below

    if (response?.status === "SUCCEEDED") {
      dispatch(
        setNotificationData({
          type: NotificationTypes.SUCCESS,
          duration: 5,
          message: <p>User added successfully</p>,
        })
      );
      form.resetFields();
      onCancel();
    } else {
      dispatch(
        setNotificationData({
          type: NotificationTypes.ERROR,
          duration: 5,
          message: <p>Failed to add user. Please try again.</p>,
        })
      );
    }
  } catch {
    // validation error — antd handles display
  }
};

  return (
   <Form
  form={form}
  layout="vertical"
  initialValues={{ userType: "normal", userGroupName: "" }}
  style={{ padding: "16px 24px" }}
>
  <Form.Item
    label="First Name"
    name="firstName"
    rules={[{ required: true, message: "Please enter first name" }]}
  >
    <Input placeholder="e.g., Test" />
  </Form.Item>

  <Form.Item
    label="Last Name"
    name="lastName"
    rules={[{ required: true, message: "Please enter last name" }]}
  >
    <Input placeholder="e.g., User" />
  </Form.Item>

  <Form.Item
    label="Email Address"
    name="emailId"
    rules={[
      { required: true, message: "Please enter email address" },
      { type: "email", message: "Please enter a valid email address" },
    ]}
  >
    <Input placeholder="e.g., test.user@zs.com" />
  </Form.Item>

  <Form.Item label="User Type" name="userType">
    {/* <Select> */}
    <Select style={{ display: "flex", alignItems: "center" }}>

      <Option value="normal">Global</Option>
      <Option value="china">China</Option>
    </Select>
  </Form.Item>

  <Form.Item label="User Group Name" name="userGroupName">
    <Input placeholder="e.g., Group A (optional)" />
  </Form.Item>

  <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
    <Button onClick={onCancel} style={{ marginRight: 8 }}>
      Cancel
    </Button>
    <Button type="primary" onClick={handleSubmit}>
      Submit
    </Button>
  </Form.Item>
</Form>
  );
};

const UserDetailsModal = ({ visible, onClose }) => {
  const [disabled, setDisabled] = useState(true);
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
  const draggleRef = React.useRef(null);

  const onStart = (_event, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) return;
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <Modal
      title={
        <div
          style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          User Details
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={480}
      destroyOnClose
      maskClosable={false}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={bounds}
          nodeRef={draggleRef}
          onStart={(event, uiData) => onStart(event, uiData)}
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
    >
      <UserDetailsForm onCancel={onClose} />
    </Modal>
  );
};

export default UserDetailsModal;